import { Box, Button, Stack, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { updateAssignedProjectAsync } from '../../services/reviewService'
import { AssignDiscipline, AssignStatus } from '../../models/Review'

interface AssignProjectRequestedProps {
  discipline: AssignDiscipline
  fileId: number
}

const AssignProjectRequestedComponent: React.FC<
  AssignProjectRequestedProps
> = ({ discipline, fileId }) => {
  const dispatch = useDispatch<any>()

  const onAcceptClick = () => {
    dispatch(
      updateAssignedProjectAsync({
        discipline: discipline.discipline,
        discipline_status: AssignStatus.InProgress,
        organization_id: 9,
        user_id: discipline.user_id,
        file_id: fileId,
      }),
    )
  }

  const onRejectClick = () => {
    dispatch(
      updateAssignedProjectAsync({
        discipline: discipline.discipline,
        discipline_status: AssignStatus.Reject,
        organization_id: 9,
        user_id: discipline.user_id,
        file_id: fileId,
      }),
    )
  }

  return (
    <Stack
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={'1rem'}
      width={'100%'}
      minHeight={'5.8rem'}
    >
      <Typography
        sx={{
          color: '#797979',
          fontSize: '0.7rem',
          fontWeight: 500,
          lineHeight: 'тormal',
          width: '60%',
          textAlign: 'center',
        }}
      >
        You've been assigned
      </Typography>
      <Box display={'flex'} gap={'1rem'}>
        <Button
          variant='outlined'
          size='small'
          onClick={() => onRejectClick()}
          sx={{
            fontSize: '0.64rem',
            border: '1px solid #FF3B47',
            textTransform: 'capitalize',
            height: '1.5rem',
            color: '#FF3B47',
          }}
        >
          Reject
        </Button>
        <Button
          variant='contained'
          size='small'
          onClick={() => onAcceptClick()}
          sx={{
            fontSize: '0.64rem',
            background: '#04002E',
            textTransform: 'capitalize',
            height: '1.5rem',
            color: '#fff',
          }}
        >
          Accept
        </Button>
      </Box>
    </Stack>
  )
}

export default AssignProjectRequestedComponent
